import { render, staticRenderFns } from "./ProductionProcesses.vue?vue&type=template&id=bc7f575e&"
import script from "./ProductionProcesses.vue?vue&type=script&lang=js&"
export * from "./ProductionProcesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports